import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  fetchOutboxEvents,
  fetchOutboxEventTypes,
  fetchOutboxSummary,
  reprocessOutboxEvent,
  type OutboxEventsParams,
} from '../api/outbox';

export function useOutboxSummary(refetchInterval: number | false = 30_000) {
  return useQuery({
    queryKey: ['admin', 'outbox', 'summary'],
    queryFn: fetchOutboxSummary,
    refetchInterval,
  });
}

export function useOutboxEvents(
  params: OutboxEventsParams,
  enabled = true,
  refetchInterval: number | false = false,
) {
  return useQuery({
    queryKey: ['admin', 'outbox', 'events', params],
    queryFn: () => fetchOutboxEvents(params),
    enabled,
    refetchInterval,
  });
}

export function useOutboxEventTypes() {
  return useQuery({
    queryKey: ['admin', 'outbox', 'event-types'],
    queryFn: fetchOutboxEventTypes,
    staleTime: 60_000,
  });
}

export function useReprocessOutboxEvent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reprocessOutboxEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'outbox'] });
    },
  });
}
